module.exports = __webpack_public_path__ + "static/img/JAGUAR.4a2649c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/JAGUAR.png
// module id = E7mi
// module chunks = 1